import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6046">
      <div data-id="element-6047">
        <div className="text-sm font-medium text-slate-900" data-id="element-6048">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-6049">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-6050">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6051" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-6052">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6053">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6054">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-6055" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6056">
          <Input label="Название платформы" defaultValue="AstroGuide" data-id="element-6057" />
          <Input label="Основной домен" defaultValue="astroguide.ru" data-id="element-6058" />
          <Input label="Email поддержки" defaultValue="support@astroguide.ru" data-id="element-6059" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-6060" />
          <div className="md:col-span-2" data-id="element-6061">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6062">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6063">
              <option value="ru" data-id="element-6064">Русский (RU)</option>
              <option value="en" data-id="element-6065">English (EN)</option>
              <option value="es" data-id="element-6066">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6067">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6068">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-6069" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6070">
          <div data-id="element-6071">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6072">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6073">
              <option value="RUB" data-id="element-6074">Российский рубль (₽)</option>
              <option value="USD" data-id="element-6075">Доллар США ($)</option>
              <option value="EUR" data-id="element-6076">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-6077">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6078">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6079">
              <option value="Europe/Moscow" data-id="element-6080">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-6081">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-6082">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6084" />} onClick={handleSave} data-id="element-6083">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-6085">
      <div className="flex justify-between items-center" data-id="element-6086">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-6087">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6089" />} data-id="element-6088">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6090">
        <table className="w-full text-left" data-id="element-6091">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6092">
            <tr data-id="element-6093">
              <th className="px-4 py-3 font-medium" data-id="element-6094">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-6095">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-6096">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-6097">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-6098">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-6099">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-6100">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6101">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6102">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-6103">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-6104">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6105">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6106">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-6107">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-6108">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-6109">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-6110">
                  <div className="flex justify-end gap-2" data-id="element-6111">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-6113" />} data-id="element-6112" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-6115" />} data-id="element-6114" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-6116">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6117">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6118">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6119">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-6120" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-6121">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6122">
                <div data-id="element-6123">
                  <div className="text-sm font-medium text-slate-900" data-id="element-6124">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-6125">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-6126">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-6127">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-6128">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6129" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6130">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6131">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6132" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-6133">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-6134" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-6135" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-6136" />

            <div className="pt-4 border-t border-slate-100" data-id="element-6137">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6138">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6140" />} onClick={handleSave} data-id="element-6139">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-6141">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6142">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6143">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6144">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-6145" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-6146">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-6147" />
            <div className="grid grid-cols-2 gap-4" data-id="element-6148">
              <Input label="Порт" defaultValue="587" data-id="element-6149" />
              <div data-id="element-6150">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6151">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6152">
                  <option value="tls" data-id="element-6153">TLS</option>
                  <option value="ssl" data-id="element-6154">SSL</option>
                  <option value="none" data-id="element-6155">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-6156" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-6157" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astroguide.ru" data-id="element-6158" />
            <Input label="Имя отправителя (From Name)" defaultValue="AstroGuide" data-id="element-6159" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-6160">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6161">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6162">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-6163" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-6164">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6165">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6167" />} onClick={handleSave} data-id="element-6166">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-6168">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6169">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6170">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6171">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-6172" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-6173">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6174">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6175">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-6176" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-6177">
            <div data-id="element-6178">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6179">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-6180" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-6181">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6182">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6184" />} onClick={handleSave} data-id="element-6183">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-6185">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6186">
        <div className="flex justify-between items-center mb-4" data-id="element-6187">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-6188">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6189" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6191" />} data-id="element-6190">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-6192">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6193">
            <div className="flex justify-between items-start mb-2" data-id="element-6194">
              <div data-id="element-6195">
                <div className="text-sm font-bold text-slate-900" data-id="element-6196">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-6197">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6198">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6199">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6200">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6201">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6202">
                <Trash2 className="w-4 h-4" data-id="element-6203" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6204">
            <div className="flex justify-between items-start mb-2" data-id="element-6205">
              <div data-id="element-6206">
                <div className="text-sm font-bold text-slate-900" data-id="element-6207">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-6208">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6209">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6210">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6211">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6212">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6213">
                <Trash2 className="w-4 h-4" data-id="element-6214" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-6215">
      <div data-id="element-6216">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-6217">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-6218">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-6219" />
    </div>;
}